import React, { Component } from 'react';
import { Waypoint } from 'react-waypoint';

import Course from './course';

class CoursesSection extends Component {
  onSectionEnter() {
    const { props } = this;
    if (props.currSection !== 'courses') {
      props.history.replace({ hash: '#courses' });
    }
  }

  render() {
    const { props } = this;
    if (!props.courses || !props.courses.length) return null;

    return (
      <div id="courses" className="research-section">
        <h3>Courses</h3>

        <div>
          <Waypoint
            fireOnRapidScroll={false}
            onEnter={(e) => this.onSectionEnter(e)}
            scrollableAncestor={window}
            topOffset={1}
            bottomOffset={window.innerHeight - 50}
          >
            {this.renderCourse(props.courses[0])}
          </Waypoint>

          {props.courses.slice(1).map((course) => this.renderCourse(course))}
        </div>
      </div>
    );
  }

  renderCourse(course) {
    return (
      <div key={course.id}>
        <Course
          title={course.title}
          description={course.description}
          thumbnailUrl={course.thumbnail_url}
          courseUrl={course.course_url}
        />
      </div>
    );
  }
}

export default CoursesSection;
